/**
 * 判斷傳入的圖片 URL 是否為使用者上傳的圖片
 * @param imageUrl - 圖片 URL
 * @returns 是否為使用者上傳的圖片
 */
const isUserUploadedImage = (imageUrl: string | null | undefined): boolean => {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return false
  }

  const userUploadPrefix = import.meta.env.VITE_USER_UPLOAD_IMAGE_PREFIX

  if (!userUploadPrefix) {
    console.warn('未設定 VITE_USER_UPLOAD_IMAGE_PREFIX 環境變數')
    return false
  }

  return imageUrl.startsWith(userUploadPrefix)
}

export { isUserUploadedImage }
